"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Checkbox_styles_1 = require("./Checkbox.styles");
const AllRowSelector = (props) => {
    return (react_1.default.createElement(Checkbox_styles_1.Checkbox, Object.assign({}, props, { inputProps: { 'aria-label': props.title }, disableRipple: true, disableFocusRipple: true, disableTouchRipple: true, onClick: (e) => e.stopPropagation() })));
};
exports.default = AllRowSelector;
//# sourceMappingURL=AllRowSelector.js.map